









import { BudgetMode } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
import { useCurrencyOption } from '@tt4b/ttam-hooks';
import { formatNumberByLangCode } from '@tt4b/infra-utils';

import ALink from '@/components/common/a-link/a-link.vue';

export default defineComponent({
  name: 'DynamicDailyBudgetTip',

  components: { ALink },

  props: {
    budget: { type: String, default: '' },
    currency: { type: String, default: '' },
    budgetMode: { type: Number as PropType<BudgetMode>, default: undefined },
  },

  setup(props) {
    const { budget, budgetMode, currency } = toRefs(props);
    const { currencyOption } = useCurrencyOption();
    const formatMoney = num =>
      formatNumberByLangCode({
        value: num,
        platformLangCode: currencyOption.value?.langCode,
        precision: currencyOption.value?.precision,
      });

    const isVisible = computed(() => budgetMode?.value === BudgetMode.DYNAMIC_DAILY_BUDGET);

    const msg = computed(() =>
      budget?.value
        ? i18n.t('module_adgroup_dynamic_daily_budget_tip', {
            budget: formatMoney(budget.value),
            currency: currency.value,
            weekBudget: formatMoney(7 * Number(budget.value)),
            mostSpendBudget: formatMoney(1.25 * Number(budget.value)),
          })
        : i18n.t('module_adgroup_dynamic_daily_budget_empty_tip'),
    );

    return {
      isVisible,
      msg,
    };
  },
});
